import { FC } from 'react';
import { StoryType } from '@edikk-edikk/country-frontend';
import { useStoryListContext } from '#advertStory/list';
import { StoryItemCircle, StoryItemContainer, StoryItemDescription } from '#advertStory/item';

type PropsType = {
  story: StoryType;
  storyIndex: number;
};

const StoryItem: FC<PropsType> = ({
  story,
  storyIndex,
}) => {
  const { openDetail } = useStoryListContext();

  const handlerClick = () => {
    openDetail(storyIndex);
  };

  return (
    <StoryItemContainer onClick={handlerClick} dataId={story.id}>
      <StoryItemCircle story={story} />
      <StoryItemDescription description={story.time} />
    </StoryItemContainer>
  );
};

export { StoryItem };
